import { render, staticRenderFns } from "./PwdResetComponent.vue?vue&type=template&id=cbff1118&scoped=true"
import script from "./PwdResetComponent.vue?vue&type=script&lang=js"
export * from "./PwdResetComponent.vue?vue&type=script&lang=js"
import style0 from "./PwdResetComponent.vue?vue&type=style&index=0&id=cbff1118&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbff1118",
  null
  
)

export default component.exports